<template>
  <v-app>
    <v-container tag="main" fluid class="pa-0 pb-9">

      <v-sheet class="d-flex d-md-none flex-column align-center px-6 px-md-0 mt-6">
        <v-img contain :src="`${cdnUrl}/assets/images/sell/guide/bubble_pickup.svg`" max-width="150" max-height="30"
               class="mb-1" alt="15時までなら当日集荷！"/>
        <v-btn
            href="/sell/offer"
            width="100%"
            max-width="327"
            height="48"
            elevation="0"
            class="d-flex white--text"
            color="secondary">今すぐ本を送る
        </v-btn>
      </v-sheet>

      <v-card
          class="d-flex flex-column flex-sm-row align-center mx-auto pt-14 pb-16 px-6 px-md-0"
          tile
          flat
          :width="xsOnly ? '100%' : 'fit-content'"
      >
        <v-img
            class="col-sm-6 col-md-auto"
            :class="{'order-last': xsOnly}"
            eager
            contain
            :width="!$vuetify.breakpoint.smOnly ? '100%' : '50%'"
            :max-width="xsOnly ? 288 : 354"
            max-height="400"
            position="center center"
            :src="`${cdnUrl}/assets/images/sell/guide/ceo-picture-w-name-2407.jpg`"
            alt="株式会社バリューブックス代表　鳥居希"/>
        <v-sheet class="col-sm-6 col-md-auto flex-row pa-0 pl-md-16 pl-sm-8 mb-7 mb-sm-0 pt-0 pt-md-8" width="100%">
          <v-card-title tag="h3" class="text-h5 text-md-h4 font-weight-bold pa-0 mb-7 mb-sm-9"
                        :style="xsOnly ? 'line-height: 2.25rem' : 'line-height: 3.25rem'">
            読み終えた本を送って<br/>暮らしを軽やかに
          </v-card-title>
          <v-card-text class="text-body-2 text-md-body-1 pa-0"
                       style="letter-spacing: 0.075em !important; line-height:1.75rem;">
            <p class="mb-1 font-weight-bold">バリューブックスは、</p>
            <p class="mb-1 font-weight-bold">会員制の古本買取サービスです。</p>
            <p class="mb-1 font-weight-bold">売りたい本をまとめたら玄関で渡すだけ。</p>
            <p class="mb-1 font-weight-bold">その日のうちに本棚が片付きます。</p>
            <p class="mb-1 font-weight-bold">まずはお気軽にお試しください。</p>
          </v-card-text>
          <v-sheet class="flex-column d-none d-md-flex justify-start mt-4">
            <v-card-actions class="flex-column justify-center pl-0" style="max-width:fit-content;">
              <v-img contain :src="`${cdnUrl}/assets/images/sell/guide/bubble_pickup.svg`" max-width="150"
                     max-height="30" class="mb-1" alt="15時までなら当日集荷！"/>
              <v-btn
                  href="/sell/offer"
                  width="327"
                  height="48"
                  elevation="0"
                  class="d-flex white--text"
                  color="secondary">
                今すぐ本を送る
              </v-btn>
            </v-card-actions>
          </v-sheet>

        </v-sheet>
      </v-card>

      <v-card
          class="d-flex align-center flex-column pt-0 pt-md-4 pb-6 pb-md-11 mb-8 mb-md-16"
          tile
          flat
          color="accent2"
      >
        <v-sheet class="d-flex flex-column my-6 mb-md-4" color="transparent">
          <v-chip
              outlined
              :color="buyingFactTextColor"
              class="text-h5 font-weight-bold mb-2"
              style="border:none;">
            <span class="font-weight-bold">年間買取件数197,707件！</span>
          </v-chip>
          <v-chip
              large
              label
              :color="buyingFactTextColor"
              text-color="white"
              class="text-h6 text-md-h5 px-4 mb-3 justify-center">
            平均買取額<span class="text-h5 text-md-h4 font-weight-bold pl-2">3,362円</span>*
          </v-chip>
          <v-chip
              outlined
              :color="buyingFactTextColor"
              class="ma-auto"
              style="border:none;">
            <span class="font-weight-bold">（※2023/1-2023/12までの期間）</span>
          </v-chip>
        </v-sheet>
        <p class="accent--text text-body-2 text-md-subtitle-1 font-weight-bold">本が好きな方にこそおすすめしたい</p>
        <v-card-title tag="h3" class="accent--text text-h4 font-weight-bold pa-0 mb-5 mb-md-8">サービスの特徴
        </v-card-title>
        <v-card-text class="pb-0 pb-md-11 d-flex flex-column flex-sm-row justify-center align-stretch">
          <v-card class="col-sm-4 pa-10 mx-md-4 mx-sm-2 mb-6 mb-sm-0 rounded-lg elevation-0"
                  :max-width="smAndDown ? null : 320">
            <v-img class="mx-auto mb-6" max-width="80" max-height="64"
                   :src="`${cdnUrl}/assets/images/sell/offer/unauthenticated/icon_yen.svg`"/>
            <v-card-title class="text-subtitle-1 pa-0 mb-3 justify-center font-weight-bold">業界トップクラスの買取額
            </v-card-title>
            <v-card-text class="text-subtitle-2 pa-0 justify-center grey--text text--darken-4">
              倉庫業務を効率化し人件費を抑えることで、業界トップクラスの価格で買取ます。
            </v-card-text>
          </v-card>
          <v-card class="col-sm-4 pa-10 mx-md-4 mx-sm-2 mb-6 mb-sm-0 rounded-lg elevation-0"
                  :max-width="smAndDown ? null : 320">
            <v-img class="mx-auto mb-6" max-width="80" max-height="64"
                   :src="`${cdnUrl}/assets/images/sell/offer/unauthenticated/icon_free.svg`"/>
            <v-card-title class="text-subtitle-1 pa-0 mb-3 justify-center font-weight-bold">返送料が無料
            </v-card-title>
            <v-card-text class="text-subtitle-2 pa-0 justify-center grey--text text--darken-4">
              査定額にご満足いただけなかった場合、返送料は不要でお返しします。
              <p class="pt-1 mb-0 text-caption accent--text">※査定後すぐにお振込みをご希望の方は返送できません。</p>
            </v-card-text>
          </v-card>
          <v-card class="col-sm-4 pa-10 mx-md-4 mx-sm-2 rounded-lg elevation-0" :max-width="smAndDown ? null : 320">
            <v-img class="mx-auto mb-6" max-width="80" max-height="64"
                   :src="`${cdnUrl}/assets/images/sell/offer/unauthenticated/icon_meisai.svg`"/>
            <v-card-title class="text-subtitle-1 pa-0 mb-3 justify-center font-weight-bold">買取明細が見られる
            </v-card-title>
            <v-card-text class="text-subtitle-2 pa-0 justify-center grey--text text--darken-4">
              どの本はいくらだったのか、買い取った本の明細をきちんとお出しします。
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-row class="px-0 px-md-4 justify-center mx-0 mb-1">
        <v-col cols="12" md="4" class="px-10" style="max-width:400px;">
          <p class="font-weight-bold text-h5" style="line-height:initial;text-align:center;">新規ご登録で<br/>お得なクーポンプレゼント
          </p>
          <p class="font-weight-bold text-subtitle-1 d-none d-md-flex">
            買取送料無料クーポンと、今すぐサイトで使える
            「500円分」のポイントをプレゼントします！<br/>
            会員限定のニュースレターでは、期間限定キャンペーン情報も配信中。
          </p>
        </v-col>
        <v-col cols="12" md="6" class="px-0 mx-0 d-flex">
          <v-card flat elevation="0" width="fit-content" href="/signup" class="px-0 mb-6 ma-md-auto mx-0">
            <v-img
                :class="$vuetify.breakpoint.mdAndUp ? 'rounded-lg' : 'rounded-0'"
                contain
                class="mx-auto"
                width="100%"
                alt="新規会員登録で今すぐ使える！限定買取クーポンプレゼント"
                :src="`${cdnUrl}`+'/assets/images/index/register-coupon-240228.png'"/>
          </v-card>
        </v-col>
        <v-col cols="12" class="d-flex d-md-none px-10">
          <p class="font-weight-bold text-subtitle-1">
            買取送料無料クーポンと、今すぐサイトで使える
            「500円分」のポイントをプレゼントします！<br/>
            会員限定のニュースレターでは、期間限定キャンペーン情報も配信中。
          </p>
        </v-col>
      </v-row>

      <v-sheet class="d-flex flex-column align-center px-6 px-md-0 mx-auto mb-5 mb-md-16">
        <v-btn
            href="/signup"
            width="327"
            height="48"
            elevation="0"
            class="d-flex white--text"
            color="secondary">
          無料会員登録はこちら
        </v-btn>
      </v-sheet>

      <v-card
          tile
          flat
          class="py-4 mb-5 mb-md-16 mx-auto"
          max-width="1024"
      >
        <v-row no-gutters class="justify-space-between">
          <v-col cols="12" md="auto" class="d-flex flex-column align-center align-md-start">
            <v-sheet width="100%" max-width="130">
              <v-divider class="grey darken-4 mt-0 mb-2"/>
              <v-img contain class="mx-auto" width="124" :src="`${cdnUrl}/assets/images/sell/guide/title_step.svg`"
                     alt="シンプル3STEP"/>
              <v-divider class="grey darken-4 mt-2 mb-3"/>
            </v-sheet>
            <v-card-title tag="h3" class="text-h5 font-weight-bold pa-0 mb-11">
              ご利用の流れ
            </v-card-title>
            <v-sheet width="100%" :max-width="smAndDown ? null : 276" class="px-10 px-md-0">
              <v-card-subtitle class="d-none d-md-block font-weight-bold pa-0 mb-5">{{
                  activeStepSlideNumber
                }}.{{ stepSlides[activeStepSlideNumber - 1].title }}
              </v-card-subtitle>
              <step-slide-image v-if="smAndDown" :slides="stepSlides" @active-number="activeStepSlideNumber = $event">
                <template #title>
                  <v-card-subtitle class="d-md-none d-inline-block white font-weight-bold px-2 py-1 mt-5">
                    {{ activeStepSlideNumber }}.{{ stepSlides[activeStepSlideNumber - 1].title }}
                  </v-card-subtitle>
                </template>
              </step-slide-image>
              <v-card-text class="pa-0">
                {{ stepSlides[activeStepSlideNumber - 1].text }}
              </v-card-text>
            </v-sheet>
          </v-col>
          <v-col cols="12" md="auto" class="d-none d-md-block">
            <step-slide-image v-if="!smAndDown" :slides="stepSlides" @active-number="activeStepSlideNumber = $event"/>
          </v-col>
        </v-row>
      </v-card>

      <v-sheet class="d-flex flex-column align-center px-6 px-md-0 mx-auto mb-5 mb-md-16">
        <v-img contain :src="`${cdnUrl}/assets/images/sell/guide/bubble_pickup.svg`" max-width="150" max-height="30"
               class="mb-1 mx-auto" alt="15時までなら当日集荷！"/>
        <v-btn
            href="/sell/offer"
            width="100%"
            max-width="327"
            height="48"
            elevation="0"
            class="d-flex white--text"
            color="secondary">今すぐ本を送る
        </v-btn>
      </v-sheet>

      <v-card
          class="d-flex flex-column flex-md-row align-center pt-9 mb-13 mb-md-16 mx-auto"
          tile
          flat
          :max-width="smAndDown ? 459 : 964"
      >
        <v-card-title tag="h3"
                      class="white d-md-none d-inline-flex align-self-start text-subtitle-1 font-weight-bold py-2 px-3 mb-n6 ml-6"
                      style="border: 2px solid #707070 !important; z-index: 1">本が届く倉庫のようす
        </v-card-title>
        <v-img
            contain
            max-width="500px"
            height="100%"
            position="center center"
            :src="`${cdnUrl}/assets/images/sell/guide/valuebooks_warehouse.jpg`"
            alt="バリューブックス上田原倉庫"
            class="mr-md-10"/>
        <v-sheet class="flex-column">
          <v-card-title tag="h3" class="d-none d-md-inline-flex text-h5 font-weight-bold py-2 px-3 mb-8"
                        style="border: 2px solid #707070">本が届く倉庫のようす
          </v-card-title>
          <v-card-text class="pa-md-0 px-6 pt-4 pb-0">長野県上田市にある倉庫には、毎日約2万冊の本が届きます。<br
              class="d-none d-md-block">在庫数は120万冊！1冊1冊丁寧に査定しています。
          </v-card-text>
        </v-sheet>
      </v-card>

      <v-sheet max-width="1024" class="mx-auto mb-md-16">
        <v-row class="grey lighten-4 mt-4 py-10 py-md-8 px-10 align-center" no-gutters>
          <v-col cols="12" class="mb-8 mb-md-1">
            <v-sheet width="100%" max-width="130" color="transparent"
                     class="text-subtitle-1 text-center font-weight-bold mx-auto">
              <v-divider class="grey darken-4 mt-0 mb-2"/>
              こちらもオススメ
              <v-divider class="grey darken-4 mt-2 mb-3"/>
            </v-sheet>
          </v-col>
          <v-col cols="12" md="auto" class="d-flex flex-column align-center">
            <v-row no-gutters>
              <v-col cols="auto" class="d-flex flex-column align-center mr-3 mr-md-4">
                <v-img class="mb-2" max-width="82" :src="`${cdnUrl}/assets/images/sell/guide/bubble_scan.svg`"
                       alt="スマホからCHECK！"/>
                <v-img max-width="100" :src="`${cdnUrl}/assets/images/common/steps/flow_scan_image.png`"
                       alt="本棚スキャンで本棚を撮影"/>
              </v-col>
              <v-col cols="auto" class="d-flex flex-column align-center ml-3 ml-md-0 mr-md-10">
                <v-img class="mb-2" max-width="82" :src="`${cdnUrl}/assets/images/sell/guide/bubble_scan.svg`"
                       alt="スマホからCHECK！"/>
                <v-img max-width="100" :src="`${cdnUrl}/assets/images/sell/guide/code_photo.png`"
                       alt="バーコードスキャンで本を撮影"/>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="pt-5 pt-md-0">
            <h3 class="mb-5 text-subtitle-1 text-md-h6 font-weight-bold text-center text-md-left">本を送る前に<br
                class="d-md-none">査定額をご確認いただけます！</h3>
            <p class="mx-auto mx-md-0" style="width: fit-content">本棚スキャンorバーコードスキャンで、<br
                class="d-none d-md-block">今すぐ売りたい本の値段をお調べいただけます。</p>
          </v-col>
          <v-col cols="12" md="auto" class="text-center text-md-right">
            <v-btn
                href="/estimate/guide"
                color="grey darken-4"
                elevation="0"
                class="white--text text-caption">
              <v-icon small class="mr-2" style="margin-top: 2px">mdi-camera</v-icon>
              <span class="font-weight-bold">本の査定額を調べる</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-sheet>


      <bookshelf-scan/>

      <v-sheet class="pt-4 d-flex flex-column align-center mx-6 mx-md-0 mb-14 mb-md-15">
        <v-img :src="`${cdnUrl}/assets/images/sell/guide/preparation.jpg`" :width="smAndDown ? 100 : 120"
               style="z-index: 1" :style="smAndDown ? 'margin-bottom: -50px' : 'margin-bottom: -60px'"
               alt="本と一緒に、ご準備ください"/>
        <v-card class="d-flex flex-column align-center pt-15 pb-10 pb-md-16 px-6 px-md-16" width="100%" max-width="800"
                tile elevation="0" style="box-shadow: 0px 0px 15px #00000012 !important;">
          <v-card-title tag="h3" class="text-subtitle-1 text-md-h5 pt-7 mb-7 mb-md-0 font-weight-bold">
            本と一緒に、ご準備ください
          </v-card-title>
          <v-card-text class="pa-0">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold mb-4">
                  <v-icon color="grey darken-4" size="10px" class="mb-1 mr-1">mdi-minus</v-icon>
                  ダンボール
                </v-list-item-title>
                <p class="text-body-2 black--text pl-3">おひとりで持ち上げられるサイズのもの。（縦・横・高さの合計が160cm以内、
                  25kgまで）</p>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold mb-4">
                  <v-icon color="grey darken-4" size="10px" class="mb-1 mr-1">mdi-minus</v-icon>
                  本人確認書類<span class="text-caption font-weight-bold pl-2">※初回のみ</span></v-list-item-title>
                <p class="text-body-2 black--text pl-3">申し込み時にアップロードください。<br/><a
                    href="/sell/faq#faq-id-card">ご利用できる身分証はこちら</a></p>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold mb-4">
                  <v-icon color="grey darken-4" size="10px" class="mb-1 mr-1">mdi-minus</v-icon>
                  銀行口座
                </v-list-item-title>
                <p class="text-body-2 black--text pl-3">ご成約後、お振込させていただく銀行口座のご登録が必要です。</p>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-sheet>

      <v-sheet class="d-flex flex-column align-center px-6 px-md-0 mx-auto mb-16">
        <v-img contain :src="`${cdnUrl}/assets/images/sell/guide/bubble_pickup.svg`" max-width="150" max-height="30"
               class="mb-1 mx-auto" alt="15時までなら当日集荷！"/>
        <v-btn
            href="/sell/offer"
            width="100%"
            max-width="327"
            height="48"
            elevation="0"
            class="d-flex white--text"
            color="secondary">今すぐ本を送る
        </v-btn>
      </v-sheet>

      <v-card
          class="d-flex flex-column pt-6 mx-auto mb-16 endpaper-list-item"
          tile
          flat
          width="fit-content"
      >
        <v-card-title tag="h3" class="col-12 text-subtitle-1 font-weight-bold pa-0 pl-6 pl-md-4 mb-6 mb-md-10">
          買取に関するおすすめの記事
        </v-card-title>
        <v-sheet class="d-flex px-4 pb-4 pb-md-1" :class="{'overflow-auto': $vuetify.breakpoint.width < 1056}">
          <v-card
              v-for="(item, index) in endpaperPostList"
              :key="index"
              :href="`/endpaper/${item.postId}/`"
              max-width="180"
              class="list-item rounded-lg mx-4"
              :class="[{'ml-0': index === 0}, {'mr-0': index === endpaperPostList.length - 1}]"
              elevation="1"
              :ripple="false"
          >
            <v-img :src="`https://wcdn.valuebooks.jp/endpaper/upload/${item.postImage}`" :alt="item.title"/>
            <v-card-title class="text-caption font-weight-bold pt-5">{{ item.title }}</v-card-title>
          </v-card>
        </v-sheet>
      </v-card>

      <v-card class="pt-8 mx-auto mb-16 px-6 px-md-0 d-flex flex-column align-center faq-contents" tile flat
              max-width="800">
        <v-card-title tag="h3" class="text-h5 font-weight-bold pa-0 mb-7">よくある質問</v-card-title>
        <v-card-text class="pa-0 mb-8 mb-md-12">
          <v-expansion-panels
              accordion
              flat
              v-model="faqPanels"
          >
            <v-expansion-panel
                v-for="(item,i) in faq"
                :key="i"
            >
              <v-divider class="my-8 my-md-11"/>
              <v-expansion-panel-header class="px-2 py-0" style="min-height: auto" @click="btnRotation(i)">
                <template #actions>
                  <v-img :src="cdnUrl + '/assets/images/common/btn_accordion_open.svg'"
                         :id="`faqicn_${i}`"
                         max-width="null"
                         class="faq-button"/>
                </template>
                <b class="text-h6 flex-grow-0 mr-4">Q</b>{{ item.title }}
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pl-2 pt-8 pt-md-10">
                <b class="text-h6 mr-4" style="line-height: 1">A</b>
                <div v-html="item.content" class="pr-12 text-body-2"></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-divider class="mt-8 mt-md-11 mb-0"/>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined href="/sell/faq" class="text-caption">よくある質問をもっと見る</v-btn>
        </v-card-actions>
      </v-card>

      <v-sheet class="px-6 px-md-0 pt-md-4 mx-auto mb-8 mb-md-13" max-width="1000">
        <v-row no-gutters :class="smAndDown ? 'flex-wrap' : 'flex-nowrap'">
          <v-col cols="12" md="auto">
            <v-img
                :max-width="smAndDown ? '100%' : 580"
                height="auto"
                :src="`${cdnUrl}/assets/images/sell/guide/vb_photo1.jpg`" class="mb-2 mb-md-0 mr-md-4"/>
          </v-col>
          <v-col cols="12" md="auto">
            <v-row no-gutters>
              <v-col cols="6" md="12" class="pr-1 pr-md-0">
                <v-img
                    contain
                    :width="smAndDown ? '100%' : '404'"
                    :max-width="smAndDown ? '100%' : '404'"
                    :height="smAndDown ? 'auto' : '172'"
                    :aspect-ratio="smAndDown ? 1 : null"
                    :src="smAndDown ? cdnUrl + '/assets/images/sell/guide/vb_photo2_sp.jpg' : cdnUrl + '/assets/images/sell/guide/vb_photo2.jpg'"
                    class="mb-md-4"/>
              </v-col>
              <v-col cols="6" md="12" class="pl-1 pl-md-0">
                <v-img
                    contain
                    :width="smAndDown ? '100%' : '404'"
                    :max-width="smAndDown ? '100%' : '404'"
                    :height="smAndDown ? 'auto' : '172'"
                    :aspect-ratio="smAndDown ? 1 : null"
                    :src="smAndDown ? cdnUrl + '/assets/images/sell/guide/vb_photo3_sp.jpg' : cdnUrl + '/assets/images/sell/guide/vb_photo3.jpg'"/>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-sheet>

      <v-card tile flat max-width="560" class="d-flex flex-column align-center mx-auto mb-3 mb-md-16">
        <v-card-title tag="h3" class="text-h6 text-md-h5 font-weight-bold pa-0 mb-11">“本が循環する社会”を目指して
        </v-card-title>
        <v-card-text class="black--text pa-0 px-10 px-md-0 mb-12 mb-md-9"
                     style="line-height: 1.8em; letter-spacing: 0;">
          <p class="ma-0">
            バリューブックスはオンライン書店でありながら、実店舗やパートナー店舗をはじめ、リアルな場所でも、本と出会う場所を作っています。 </p>
          <p class="ma-0">
            また、買い取れなかった本の一部を保育園や福祉施設に寄贈する「ブックギフト」や、移動型書店「ブックバス」など、さまざまな活動を通じて、“本が循環する社会”を目指しています。</p>
        </v-card-text>
        <v-card tile flat href="/endpaper/4435/" class="px-6 px-md-0">
          <v-img
              width="100%"
              max-width="440"
              contain
              :src="smAndDown ? cdnUrl + '/assets/images/sell/guide/banner_story_sp.jpg' : cdnUrl + '/assets/images/sell/guide/banner_story.jpg'"
              alt="本屋が本を届けながら考えていること"/>
        </v-card>
      </v-card>

    </v-container>
  </v-app>

</template>

<script>
import StepSlideImage from "../../molecules/purchase/step-slide-image.vue";
import BookshelfScan from "../../organisms/static/buy/bookshelf-scan.vue";
import TimerDisplay from "../../atoms/timer-display.vue";

export default {
  name: "buy-top",
  components: {
    StepSlideImage,
    BookshelfScan,
    TimerDisplay
  },
  data() {
    return {
      cdnUrl: VueConfig.cdn_url,
      stepSlides: [
        {
          img: VueConfig.cdn_url + '/assets/images/sell/guide/step3_photo.jpg',
          title: '箱に詰める',
          text: '送る本が決まったらまとめてダンボールへ。1箱につき500円の送料をいただくので、まとめて梱包するのがお得です。'
        },
        {
          img: VueConfig.cdn_url + '/assets/images/sell/guide/step4_photo.jpg',
          title: '集荷を申し込む',
          text: '買取申込みページで集荷依頼をすれば、指定時間にクロネコヤマトさんがご自宅まで伺います。伝票のご用意も不要です。'
        },
        {
          img: VueConfig.cdn_url + '/assets/images/sell/guide/step5_photo.jpg',
          title: '査定完了！即入金',
          text: '査定が完了したらメールでお知らせ。査定額に納得いただければご入金、そうでない場合も返送料無料でお返しします。'
        }
      ],
      endpaperPostList: [
        {
          postId: '13030',
          postImage: 'サムネイル-520x292.png',
          title: '数字で振り返る｜バリューブックスの買取実績 【2023年度版】',
        },
        {
          postId: '6189',
          postImage: 'danborukonpou18-300x163.png',
          title: 'ダンボールに本やCDをきれいに詰める梱包テクニック'
        },
        {
          postId: '5633',
          postImage: '2kaimemoushikomi051-300x163.jpg',
          title: '２回目からのお申し込みは１０秒で完了！『集荷日』と『箱数』だけのかんたん買取'
        },
        {
          postId: '5895',
          postImage: 'souryounazeアイキャッチ-300x163.jpg',
          title: '一箱あたりの買取額がポイント！送る前の選別で、送料有料サービスをお得に活用する'
        },
        {
          postId: '10932',
          postImage: 'point-300x163.jpg',
          title: 'キャンペーンでもらえる！バリューブックス ポイントのご利用方法【最新クーポン情報も掲載！】'
        },
      ],
      faq: [
        {
          'title': '一度の申込みで送れるのは何箱まで？',
          'content': '現在' + VueConfig.sell.maxNumberOfPackages + '箱までお申し込み可能です。<br />なお、繁忙期（年度末・GW・お盆・年末年始など）は、お申し込み可能箱数に、変更が生じる場合がございます。'
        },
        {
          'title': '申込み後に集荷のキャンセルはできる？',
          'content': 'できます。お問い合わせフォームよりご連絡くださいませ。 <br /><a href="/inquiry">お問い合わせフォーム</a>'
        },
        {
          'title': '箱数の変更をしたい時は？',
          'content': '集荷日時や箱数の変更は、マイページの「買取の状況」にて変更できます（集荷日の前日、19時まで）。<br />上記期限を過ぎた場合、変更はお受けできかねますので、ご了承ください。'
        },
        {
          'title': 'クーポンコードはどこで使えますか？',
          'content': '買取申込みページや、購入の際の注文画面にてご入力ください。特典が適用されます。<br />また、サイトにて開催中のキャンペーンと合わせてご利用できますが、他のクーポンコードとは併用できませんのでご注意ください。'
        },
      ],
      activeStepSlideNumber: 1,
      faqPanels: null,
      campaignStartDate: VueConfig.buyCampaignMessageDisplay.startDate,
      campaignEndDate: VueConfig.buyCampaignMessageDisplay.endDate,
      buyCampaignMessage: VueConfig.buyCampaignMessageDisplay.message,
      buyingFactTextColor: "#DBAC3B",
    };
  },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    btnRotation(id) {
      let faqicn = document.getElementById('faqicn_' + id);
      if (faqicn.style.transform != "rotate(45deg)") {
        faqicn.style.transform = "rotate(45deg)";
      } else {
        faqicn.style.transform = "rotate(0)";
      }

      let i = 0;
      for (let item in this.faq) {
        if (i != id) {
          let nonfocused_faqicn = document.getElementById('faqicn_' + i);
          nonfocused_faqicn.style.transform = "rotate(0)";
        }
        i++;
      }
    }
  }
}
</script>

<style scoped lang="scss">
main {
  min-width: unset;
}

.faq-button {
  transition: transform 0.3s ease-in-out;
}

::v-deep {
  h2.contents-title {
    small {
      color: #BA976A;
      padding-top: 2px;
      line-height: 1.5em;
      letter-spacing: 0.075em !important;
    }

    span {
      color: #755223;
      letter-spacing: 0.075em !important;
    }
  }

  .faq-contents {
    .v-expansion-panel-content__wrap {
      display: flex;
      padding: 0;
    }
  }

  .endpaper-list-item {
    .v-card.list-item {
      &:last-child {
        position: relative;
        overflow: visible;

        &:after {
          position: absolute;
          top: 0;
          left: 100%;
          content: "";
          width: 16px;
          height: 1px;
        }
      }
    }
  }
}

@media screen and (max-width: 375px) {
  ::v-deep {
    .first-view-image {
      .v-image__image--cover {
        background-size: 138px !important;
      }
    }
  }
}

@media screen and (min-width: 376px) and (max-width: 960px) {
  ::v-deep {
    .first-view-image {
      .v-image__image--cover {
        background-size: 178px !important;
      }
    }
  }
}
</style>